// axiosConfig.js

import authObject from 'services/auth.service';
import axios from 'axios';
// import authHeader from './authHeader'; // Adjust the import based on your project structure

// URL segments exempted from the app-wide 403-redirect safeguard: requests
// to the notification-criteria and contact-blacklist endpoints keep their
// 403 responses so the RFQ Notifications page can display the business
// message they carry (see apiErrors.js / MLO-026 Behavior §5). The shared
// lookup endpoints this page also calls (sources, customers, deduplicated
// contacts, truck sizes) are NOT in this list and keep the redirect.
export const EXEMPT_403_URL_SEGMENTS = [
  'rfq/notification-criteria/',
  'rfq/contact-blacklist/',
];

// Add a request interceptor (optional)
axios.interceptors.request.use(
  config => {
    // Optionally modify the request config
    // For example, attach auth headers or log request info
    // config.headers = {
    //   ...config.headers,
    //   ...authHeader(), // Add auth headers globally
    // };
    return config;
  },
  error => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Handle 401 Unauthorized
          console.warn('Unauthorized access - redirecting to login');
          authObject.logout()
          // Optionally, redirect to login page or refresh token
          window.location.href = '/login';
          break;

        case 403: {
          // Handle 403 Forbidden — exempted endpoints keep their response
          // so the page can display the backend's own message instead of
          // being redirected away. Missing config means we can't tell
          // where the request went, so the safe default is to redirect.
          const requestUrl = error.config?.url;
          const isExemptFrom403Redirect =
            typeof requestUrl === 'string' &&
            EXEMPT_403_URL_SEGMENTS.some(segment => requestUrl.includes(segment));

          if (!isExemptFrom403Redirect) {
            console.warn('Access forbidden - redirecting to home');
            window.location.href = '/'
          }
          break;
        }

        default:
          // Handle other status codes if needed
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default axios; // You can still export default axios if needed
